import React from 'react';
import _ from 'lodash';
import clsx from "clsx";

import ScrollMenu from "react-horizontal-scrolling-menu";
/* Material-UI Components */
import Grid from '@material-ui/core/Grid';
import IconButton from "@material-ui/core/IconButton";

/* BCA modules*/
import {MissingRequiredIcon} from "../../../../components/Icons/WarningIcon";
import SkipIcon from "../../../../components/Icons/SkipIcon";

import useStyles from './styles';


export default (props) => {
  const {
    title,
    menuItems,
    currMenu,
    onDeleteProcessClick,
    isFinished,
    navigateToPrevMenu,
  } = props;

  const classes = useStyles();

  const MenuItem = ({item, idx}) => {
    const isActive = currMenu === idx;
    const isDone = item.isDone; // function so better call it once
    const hasMissingInfo = item.isNewDesign && item.getHasMissingAnswers();
    const goToMenu = !isFinished && !!navigateToPrevMenu && currMenu > idx ? () => navigateToPrevMenu(item.uid) : undefined;
    const hasNote = item.isNewDesign && (hasMissingInfo || item.hasSkippedSteps());

    return (
      <div className={clsx(classes.menuItem, isActive && 'active', isDone && 'done', !!goToMenu && 'clickable')} onClick={goToMenu}>
        {hasNote
          ? (hasMissingInfo ? <MissingRequiredIcon className={classes.warningIcon} /> : <SkipIcon className={classes.warningIcon} />)
          : isDone && (<i className={'fa fa-check-circle'} />)
        }
        {item.name}
        {isActive && <i className={clsx('fa fa-lg fa-angle-up', hasNote && 'has-missing-info')} />}
      </div>
    )
  };

  return (
    <React.Fragment>
      <Grid container wrap={"nowrap"} className={classes.topContainer} alignItems={'center'}>
        <Grid item className={classes.header}>
          {title}
          {_.isFunction(onDeleteProcessClick) && !isFinished &&
            <IconButton className={classes.deleteBtn} color={"primary"} aria-label="close" onClick={onDeleteProcessClick}>
              <i className={"far fa-trash-alt"} />
            </IconButton>
          }
        </Grid>
        <Grid item className={classes.menuContainer}>
          <ScrollMenu
            alignCenter={false}
            wheel={false}
            scrollToSelected={true}
            hideSingleArrow={true}
            arrowLeft={<div>{"<"}</div>}
            arrowRight={<div>{">"}</div>}
            dragging={false}
            selected={menuItems && menuItems[currMenu] && menuItems[currMenu].uid}
            data={menuItems && menuItems.map((item, idx) => <MenuItem key={item.uid} item={item} idx={idx} />)}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  )
}